import {
  GET_ADD_PROPERTY_OWNER_LISTINGS_REQUEST,
  GET_ADD_PROPERTY_OWNER_LISTINGS_SUCCESS,
  GET_ADD_PROPERTY_OWNER_LISTINGS_FAIL,
  ADD_PROPERTY_OWNER_REQUEST,
  ADD_PROPERTY_OWNER_SUCCESS,
  ADD_PROPERTY_OWNER_FAIL,
  GET_PROPERTY_OWNERS_REQUEST,
  GET_PROPERTY_OWNERS_SUCCESS,
  GET_PROPERTY_OWNERS_FAIL,
  EDIT_PROPERTY_OWNER_REQUEST,
  EDIT_PROPERTY_OWNER_SUCCESS,
  EDIT_PROPERTY_OWNER_FAIL,
  DELETE_PROPERTY_OWNER_REQUEST,
  DELETE_PROPERTY_OWNER_SUCCESS,
  DELETE_PROPERTY_OWNER_FAIL
} from "./propertyOwnerTypes";

const initialState = {
  propertyOwners: [],
  listings: [],
  loading: false,
  error: null
};

const propertyOwnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADD_PROPERTY_OWNER_LISTINGS_REQUEST:
    case ADD_PROPERTY_OWNER_REQUEST:
    case GET_PROPERTY_OWNERS_REQUEST:
    case EDIT_PROPERTY_OWNER_REQUEST:
    case DELETE_PROPERTY_OWNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_ADD_PROPERTY_OWNER_LISTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        listings: action.payload,
        error: null
      };

    case ADD_PROPERTY_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    case GET_PROPERTY_OWNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        propertyOwners: action.payload,
        error: null
      };

    case EDIT_PROPERTY_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        propertyOwners: state.propertyOwners.map((owner) => (owner._id === action.payload._id ? action.payload : owner)),
        error: null
      };

    case DELETE_PROPERTY_OWNER_SUCCESS:
      return {
        ...state,
        loading: false,
        propertyOwners: state.propertyOwners.filter((owner) => owner._id !== action.payload),
        error: null
      };

    case GET_ADD_PROPERTY_OWNER_LISTINGS_FAIL:
    case ADD_PROPERTY_OWNER_FAIL:
    case GET_PROPERTY_OWNERS_FAIL:
    case EDIT_PROPERTY_OWNER_FAIL:
    case DELETE_PROPERTY_OWNER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default propertyOwnerReducer;
